import React, { lazy } from 'react'
import { Route } from 'react-router'
import { SubRouter } from '@/router/SubRouter'

const Index = lazy(() => import('./Index'))
const Edit = lazy(() => import('./Edit'))

export const OperationsAirportCostsRouter = React.memo(() => (
  <SubRouter loggedIn roles={['role--operations--airport-costs']}>
    <Route index element={<Index />} />
    <Route path='new' element={<Edit />} />
    <Route path=':id' element={<Edit />} />
  </SubRouter>
))
